module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-stone-path-background-remnants.cdf2b413.png";